import type { ExtractPropTypes, UnwrapNestedRefs } from "vue";
import { reactive } from "vue";
import { props } from "quick-vue-components/index";
import { getNoticesList } from "@user-center/api/common";
import { getToken } from "@user-center/utils/auth";
import {
  filterActiveNotices,
  isNoticeHiddenByScope,
  localizeNotices,
} from "./noticeUtils";
import { useMainStore } from "~/composables/store";

export interface NoticeBarType {
  noticeBarState: UnwrapNestedRefs<NoticeBarStateType>;
  getListAction():void
}
export type NoticeBarStateType = {
  noticeDataVisible: boolean;

  viewNoticeIdx: number;
  findNoticeDatas: any[];
};
export const NoticeBarProps = props.buildProps({
  isShowBar: {
    type: Boolean,
    default: true,
  },
  autoPopup: {
    type: Boolean,
    default: true,
  },
  pageSize: {
    type: Number,
    default: 99,
  },
  storageScope: {
    type: String,
    default: "default",
  },
});
export type NoticeBarPropsType = ExtractPropTypes<typeof NoticeBarProps>;

export function useGetNoticesList(props?:NoticeBarPropsType): NoticeBarType {
  const store = useMainStore();
  const noticeBarState: UnwrapNestedRefs<NoticeBarStateType> = reactive({
    noticeDataVisible: false,
    viewNoticeIdx: 0,
    findNoticeDatas: [],
  });
  function resetNoticeState() {
    noticeBarState.findNoticeDatas = [];
    noticeBarState.viewNoticeIdx = 0;
    noticeBarState.noticeDataVisible = false;
    store.setHasVisibleNotice(false);
  }
  function getListAction() {
    if (!getToken()) {
      resetNoticeState();
      return;
    }

    getNoticesList({ pageNo: 0, pageSize: props?.pageSize || 99 }).then((res: any): void => {
      if (res.success && res.data && res.data.dataList) {
        const findItems: any[] = localizeNotices(
          filterActiveNotices(res.data.dataList || [])
        );
        noticeBarState.findNoticeDatas = findItems;
        noticeBarState.viewNoticeIdx = 0;
        store.setHasVisibleNotice(findItems.length > 0);
        if (findItems.length) {
          if (
            props?.autoPopup !== false &&
            !window.sessionStorage.getItem("isNoticeBarOpen") &&
            !isNoticeHiddenByScope(props?.storageScope || "default")
          ) {
            window.sessionStorage.setItem("isNoticeBarOpen", "1");
            noticeBarState.noticeDataVisible = true;
          }
        } else {
          noticeBarState.noticeDataVisible = false;
        }
      } else {
        resetNoticeState();
      }
    }).catch(() => {
      resetNoticeState();
    });
  }

  return {
    getListAction,
    noticeBarState,
  };
}
